const fadeTrigger = document.querySelector('.js-root-target');
const fadeTrigger2 = document.querySelector('.js-root-target2');
if (fadeTrigger) {

    //関数を定義
    const callback = (entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const fadeTarget = document.querySelector('.js-active-target');
                fadeTarget.classList.add('is-active');
            }
        });
    }

    const callback2 = (entries2) => {
        entries2.forEach(entry2 => {
            if (entry2.isIntersecting) {
                const fadeTarget = document.querySelector('.js-active-target');
                if (fadeTarget.classList.contains('is-active')) {
                    fadeTarget.classList.remove('is-active');
                }
            }
        });

    }

    //optionsを定義
    const options = {
        root: null,
    }
    const options2 = {
        rootmargin: '-50% 0px -50% 0px',
    }

    //IntersectionObserverを生成
    const observer = new IntersectionObserver(callback, options);
    const observer2 = new IntersectionObserver(callback2, options2);

    //監視対象を登録
    observer.observe(fadeTrigger);
    observer2.observe(fadeTrigger2);
}